import { render } from "./gameImageSlider.vue?vue&type=template&id=68a50530&scoped=true"
import script from "./gameImageSlider.vue?vue&type=script&lang=js"
export * from "./gameImageSlider.vue?vue&type=script&lang=js"

import "./gameImageSlider.vue?vue&type=style&index=0&id=68a50530&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a50530"]])

export default __exports__